import React, { SVGProps } from 'react';

export default function TwilioLogo(props: { className?: string }) {
  return (
    <div className={props.className}>
      <img height={30} src="https://storage.googleapis.com/lana-health-website/img/app/ucsf/ucsf-logo-dark.png" />
    </div>
  );
}
